import MyLogo from '../../assets/images/logomobali_lab.png';

import { useNavigate } from 'react-router-dom';
import { HeadingCustom } from '../atoms/HeadingCustom';

export const Brand = ({ size = "small", title=false, setIsOpen = () => {}, isOpen = false }) => {

   const mySize = {
      small:"w-12 h-12",
      medium:"w-24 h-24",
      large:"w-32 h-32"
   }


   const navigate = useNavigate();
   
   const handleClick = () => {
      navigate("/");
      setIsOpen(false)
   }

   return (
      <div className='flex items-center justify-center gap-2 cursor-pointer' onClick={ handleClick }>
         { title && <HeadingCustom size="small" className="order-last mb-0 font-medium hover:text-orange-500 transition-all easeInOut ">Lab mobali</HeadingCustom> }
         <div className={`${mySize[size]}`}>
            <figure className={`${mySize[size]}`} >
               <img src={ MyLogo } alt="Logo du site Lab Mobali" className='w-full h-full object-contain' />
            </figure>
         </div>
      </div>
         
   )
}